exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-lockscreen > .modal-content {\n    border-radius: 10px;\n}\n\n.modal-header > .close {\n    display: none;\n}\n\n.modal-lockscreen {\n  background-color: rgba(0, 0, 0, 0.4);\n  -webkit-backdrop-filter: blur(9px);\n          backdrop-filter: blur(9px);\n}\n\n#modal-lockscreen {\n    margin-top: 150px !important;\n}\n\n.modal-lockscreen.show {\n    opacity: 1;\n}", ""]);

// exports
